<template>
  <div class="home">
    <!-- 首页导航栏 -->
    <header ref="bannerImg">
      <el-row>
        <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
          <el-row>
            <el-col :span="4" style="min-width:170px;">
              <div
                class="grid-content bg-purple logo"
                :style="flag ? 'color:#000;': 'color:#fff;' "
                @click="hreftwo"
              >
                <img :src=" flag ? imgurl.black :imgurl.white" alt ref="image" />
                <span>
                  <b>经理云</b>
                </span>
              </div>
            </el-col>
            <el-col :span="13" class="nav_right" style="min-width:635px;">
              <div class="topsbox" style="float: right;">
                <div class="tops">
                  <router-link to="/" :style="flag ? 'color:#000;': 'color:#fff;' ">首页</router-link>
                </div>
                <div class="tops">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <a
                        href="#"
                        :style="flag ? 'color:#000;': 'color:#fff;' "
                        style="font-size:16px"
                      >产品</a>
                    </span>
                    <el-dropdown-menu slot="dropdown" style="width:100%;">
                      <el-row class="pulldown">
                        <div
                          style="margin:0 auto;overflow: hidden;display: flex;justify-content:center"
                        >
                          <el-col :span="10" style="min-width:888px">
                            <div
                              class="grid-content bg-purple-dark pulldown_b"
                              style="margin-right: 100px;"
                            >
                              <p>经理云产品</p>
                              <p>
                                <router-link to="/retail">
                                  <img src="../assets/57.png" alt /> 零售版
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/warehouse">
                                  <img src="../assets/仓库@2x(1).png" alt /> 仓库版
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/wholesaler">
                                  <img src="../assets/批发商@21x.png" alt /> 批发商版
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/process">
                                  <img src="../assets/加工中心@2x1.png" alt />加工中心版
                                </router-link>
                              </p>
                            </div>
                            <div
                              class="grid-content bg-purple-dark pulldown_b"
                              style="margin-right: 91px;"
                            >
                              <p>&nbsp;</p>
                              <p>
                                <router-link to="/businessProduct">
                                  <img src="../assets/商家后台@2x.png" alt /> 商家后台
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/publicNumberProduct">
                                  <img src="../assets/公众号@2x.png" alt /> 微信公众
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/smallProgramProduct">
                                  <img src="../assets/小程序(1)@2x.png" alt /> 微信小程序
                                </router-link>
                              </p>
                            </div>
                            <div class="pulldown_b" style="margin-right: 109px;">
                              <span
                                style="display:block;width: 1px;height:290px;background: rgba(210, 210, 210, 1);border-radius: 1px;"
                              ></span>
                            </div>
                            <div
                              class="grid-content bg-purple-dark pulldown_b"
                              style="margin-right: 135px;"
                            >
                              <p>硬件产品</p>
                              <p>
                                <router-link to="/money">
                                  <img src="../assets/收银机@2x.png" alt /> 收银机
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/dispose">
                                  <img src="../assets/打印(2)@2x.png" alt /> 打印设备
                                </router-link>
                              </p>
                            </div>
                          </el-col>
                        </div>
                      </el-row>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="tops">
                  <el-dropdown placement="bottom">
                    <span class="el-dropdown-link">
                      <a
                        href="#"
                        :style="flag ? 'color:#000;': 'color:#fff;' "
                        style="font-size:16px"
                      >使用教程</a>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-row class="pulldown">
                        <el-col>
                          <div class="pulldown_b" style="padding:0 40px ">
                            <p style="margin-left:10px;">视频与文档</p>
                            <p>
                              <router-link to="/course/shop">
                                <img src="../assets/1视频@2x.png" width="28px" alt /> 特色功能使用视频
                              </router-link>
                            </p>
                            <p style="margin-top:20px;">
                              <router-link to="/course/help">
                                <img src="../assets/文档@2x.png" width="30px" alt /> 帮助文档
                              </router-link>
                            </p>
                          </div>
                        </el-col>
                      </el-row>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="tops">
                  <router-link to="/aboutour" :style="flag ? 'color:#000;': 'color:#fff;' ">关于我们</router-link>
                </div>
                <div class="tops">
                  <router-link to="/cooperate" :style="flag ? 'color:#000;': 'color:#fff;' ">合作</router-link>
                </div>
                <div class="tops login">
                  <button
                    to="/"
                    :style="flag ? 'color:#000;border-color:#000': 'color:#fff;border-color:#fff'"
                    @click="logins"
                  >登录</button>
                </div>
              </div>
            </el-col>
            <div
              class="nav_right_phone"
              @click="open = !open"
              :style="flag ? 'color:#000;': 'color:#fff;' "
            >
              <i :class=" open ?  'el-icon-arrow-down': 'el-icon-arrow-right' "></i>首页
            </div>
          </el-row>
        </el-col>
      </el-row>
    </header>

    <!-- 移动端头部 -->
    <transition name="el-fade-in">
      <div class="caidan" v-show="open">
        <ul>
          <li>
            <router-link to="/">首页</router-link>
          </li>
          <li @click="openinfo = !openinfo">
            <a href="javascript:;">
              产品
              <i :class=" openinfo ? 'el-icon-arrow-down': 'el-icon-arrow-right' "></i>
            </a>
          </li>
          <transition name="el-fade-in">
            <div class="info" v-show="openinfo">
              <p>
                <router-link to="/retail">零售版</router-link>
              </p>
              <p>
                <router-link to="/warehouse">仓库版</router-link>
              </p>
              <p>
                <router-link to="/wholesaler">批发商版</router-link>
              </p>
              <p>
                <router-link to="/process">加工中心版</router-link>
              </p>
              <p>
                <router-link to="/businessProduct">商家后台</router-link>
              </p>
              <p>
                <router-link to="/publicNumberProduct">微信公众号</router-link>
              </p>
              <p>
                <router-link to="/smallProgramProduct">微信小程序</router-link>
              </p>
              <p>
                <router-link to="/money">收银机</router-link>
              </p>
              <p>
                <router-link to="/dispose">硬软件配置</router-link>
              </p>
            </div>
          </transition>
          <li @click="openinfo1 = !openinfo1">
            <a href="javascript:;">
              使用教程
              <i :class=" openinfo1 ? 'el-icon-arrow-down': 'el-icon-arrow-right' "></i>
            </a>
          </li>
          <transition name="el-fade-in">
            <div class="info" v-show="openinfo1">
              <p>
                <router-link to="/course/shop">特色功能使用视频</router-link>
              </p>
              <p>
                <router-link to="/course/help">帮助文档</router-link>
              </p>
            </div>
          </transition>
          <li>
            <router-link to="/aboutour">关于我们</router-link>
          </li>
          <li>
            <router-link to="/cooperate">合作</router-link>
          </li>
          <li>
            <a href="javascript:;" @click="logins">登录</a>
          </li>
        </ul>
      </div>
    </transition>

    <headers></headers>

    <!-- <div class="banner" ref="banner">
      <video src="../assets/video/banner视频.mp4" muted loop autoplay width="100%"></video>
    </div>-->

    <!-- 移动的视频 -->
    <div class="banner1" ref="banner">
      <video
        src="../assets/video/bannerVideo.mp4"
        webkit-playsinline
        playsinline
        x5-playsinline
        autoplay
        muted
        loop
        width="100%"
      ></video>
    </div>
    <!-- 移动端图片 -->
    <div class="banners">
      <img src="../assets/images/homeImg/home3.png" width="100%" alt />
    </div>

    <el-row class="banner_b">
      <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
        <el-row>
          <el-col :span="8" class="lingshou" style="padding-left:66px">
            <div style="width:60px;height:60px;float: left;margin-right:21px;">
              <img src="../assets/店家管理@2x.png" alt width="66px" />
            </div>
            <div class="right">
              <p>店家管理</p>
              <p>收银/管理/营销等全方位服务</p>
            </div>
          </el-col>
          <el-col :span="8" class="lingshou" style="padding-left:66px">
            <div style="width:60px;height:60px;float: left;margin-right:21px;">
              <img src="../assets/店家管理@2x.png" alt width="66px" />
            </div>
            <div class="right">
              <p>零售系统</p>
              <p>扫码/验光/共享等方便快捷</p>
            </div>
          </el-col>
          <el-col :span="8" class="lingshou" style="padding-left:66px">
            <div style="width:60px;height:60px;float: left;margin-right:21px;">
              <img src="../assets/店家管理@2x.png" alt width="66px" />
            </div>
            <div class="right">
              <p>微营销</p>
              <p>服务号/会员/自动提醒等运营详情</p>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- 产品介绍 -->
    <el-row style="background-color:#fff;margin-top:5px" class="chanpin">
      <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
        <div class="newbox">
          <div class="newbox_t">
            <div class="product_t">
              <h2>产品介绍</h2>
              <p>PRODUCT INTRODUCTION</p>
            </div>
            <div class="product_b">
              <h3>
                收银机
                <i class="el-icon-remove"></i> 零售版本
              </h3>
              <p>零售版专业为零售店定制的一站式服务系统</p>
              <p>扫码销售/快捷验光，会员共享，库存独立和共享，员工打卡/报销/交接班等</p>
            </div>
          </div>
          <el-row class="newbox_top">
            <el-col :span="12" :offset="8">
              <span :class="isactive==1 ? 'active' :'' " @click="isactive =1">页面原型</span>
              <span :class="isactive==2 ? 'active' :'' " @click="isactive =2">视频展示</span>
            </el-col>
          </el-row>
          <el-row class="newbox_bb" :style="isactive == 1 ? 'display:block': 'display:none' ">
            <el-col :span="15" style="height:390px">
              <div class="newbox_img" :style="is_actives == 1 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/yinye.png" alt width="100%" height="100%" />
              </div>
              <div class="newbox_img" :style="is_actives == 2 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/vip.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives == 3 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/newyan.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives == 4 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/shopSelet.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives == 5 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/car.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives == 6 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/jiezhang.png" alt width="100%" />
              </div>
            </el-col>
            <el-col :span="8" :offset="1" style="margin-top:60px;padding-left:50px;">
              <ul class="newbox_ul">
                <li :class="is_actives == 1? 'is_active' : '' " @mousemove="is_actives=1">
                  <p>
                    <img src="../assets/营业厅@2x.png" alt />
                  </p>
                  <p>营业厅</p>
                </li>
                <li :class="is_actives == 2? 'is_active' : '' " @mousemove="is_actives=2">
                  <p>
                    <img src="../assets/顾客@2x.png" alt />
                  </p>
                  <p>顾客信息</p>
                </li>
                <li :class="is_actives == 3? 'is_active' : '' " @mousemove="is_actives=3">
                  <p>
                    <img src="../assets/验光@2x.png" style="height:25px" alt />
                  </p>
                  <p>新建验光</p>
                </li>
                <li :class="is_actives == 4? 'is_active' : '' " @mousemove="is_actives=4">
                  <p>
                    <img src="../assets/商品@2x.png" alt />
                  </p>
                  <p>商品选择</p>
                </li>
                <li :class="is_actives == 5? 'is_active' : '' " @mousemove="is_actives=5">
                  <p>
                    <img src="../assets/购物车@2x.png" alt />
                  </p>
                  <p>购物车</p>
                </li>
                <li :class="is_actives == 6? 'is_active' : '' " @mousemove="is_actives=6">
                  <p>
                    <img src="../assets/结算@2x.png" alt />
                  </p>
                  <p>结算</p>
                </li>
              </ul>
            </el-col>
          </el-row>
          <el-row class="newbox_cc" :style="isactive == 2 ? 'display:block': 'display:none' ">
            <el-col :span="21" :offset="1">
              <!-- <video src="../assets/video/零售版.mp4" width="100%" controls></video> -->
              <a
                target="_blank"
                href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODM3MS5zaHRtbA==.html"
              >
                <img src="../assets/images/homeImg/video.png" width="100%" alt />
              </a>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :offset="20">
              <router-link to="/retail" class="btn" tag="button">查看详情</router-link>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 收银机仓库版本 -->
    <el-row style="background-color:#F0EFEF;margin-top:5px" class="cangku">
      <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
        <div class="newbox">
          <div class="newbox_t">
            <div class="product_b">
              <h3>
                收银机
                <i class="el-icon-remove"></i> 仓库版本
              </h3>
              <p>零售版专业为零售店定制的一站式服务系统</p>
              <p>扫码销售/快捷验光，会员共享，库存独立和共享，员工打卡/报销/交接班等</p>
            </div>
          </div>
          <el-row class="newbox_top">
            <el-col :span="12" :offset="8">
              <span :class="isactive1==1 ? 'active' :'' " @click="isactive1 =1">页面原型</span>
              <span :class="isactive1==2 ? 'active' :'' " @click="isactive1 =2">视频展示</span>
            </el-col>
          </el-row>
          <el-row class="newbox_bb" :style="isactive1 == 1 ? 'display:block': 'display:none' ">
            <el-col :span="8" style="margin-top:60px;padding-left:0px;">
              <ul class="newbox_ul">
                <li :class="is_actives1 == 1? 'is_active' : '' " @mousemove="is_actives1=1">
                  <p>
                    <img src="../assets/打印@2x.png" alt />
                  </p>
                  <p>打印设置</p>
                </li>
                <li :class="is_actives1 == 2? 'is_active' : '' " @mousemove="is_actives1=2">
                  <p>
                    <img src="../assets/模板导入@2x.png" alt />
                  </p>
                  <p>模板导入</p>
                </li>
                <li :class="is_actives1 == 3? 'is_active' : '' " @mousemove="is_actives1=3">
                  <p>
                    <img src="../assets/标签@2x.png" alt />
                  </p>
                  <p>打印标签</p>
                </li>
                <li :class="is_actives1 == 4? 'is_active' : '' " @mousemove="is_actives1=4">
                  <p>
                    <img src="../assets/商品入库@2x.png" alt />
                  </p>
                  <p>商品入库</p>
                </li>
                <li :class="is_actives1 == 5? 'is_active' : '' " @mousemove="is_actives1=5">
                  <p>
                    <img src="../assets/仓库@2x.png" alt />
                  </p>
                  <p>分店入库</p>
                </li>
              </ul>
            </el-col>
            <el-col :span="15" :offset="1" style="height:390px">
              <div class="newbox_img" :style="is_actives1 == 1 ? 'display:block': 'display:none' ">
                <img src="../assets/cangku.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives1 == 2 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/daoru.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives1 == 3 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/1.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives1 == 4 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/11.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives1 == 5 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/cangkuban.png" alt width="100%" />
              </div>
            </el-col>
          </el-row>
          <el-row class="newbox_cc" :style="isactive1 == 2 ? 'display:block': 'display:none' ">
            <el-col :span="21" :offset="1">
              <!-- <video src="../assets/video/仓库版.mp4" width="100%" controls></video> -->
              <a target="_blank" href="http://www.56.com/u80/v_MTU5MDk0Mzg5.html">
                <img src="../assets/images/homeImg/video.png" width="100%" alt />
              </a>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :offset="20">
              <router-link
                to="/warehouse"
                class="btn"
                tag="button"
                style="background: transparent"
              >查看详情</router-link>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 收银机  批发商 -->
    <el-row style="background-color:#fff;margin-top:5px" class="pifashang">
      <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
        <div class="newbox">
          <div class="newbox_t">
            <div class="product_b">
              <h3>
                收银机
                <i class="el-icon-remove"></i> 批发商版本
              </h3>
              <p>批发商版本让管理更加便捷。</p>
              <p>商品入库/商品出库/库存/库存预警提醒，客户管理，订单管理/筛选商品价格…</p>
            </div>
          </div>
          <el-row class="newbox_top">
            <el-col :span="12" :offset="8">
              <span :class="isactive2==1 ? 'active' :'' " @click="isactive2 =1">页面原型</span>
              <span :class="isactive2==2 ? 'active' :'' " @click="isactive2 =2">视频展示</span>
            </el-col>
          </el-row>
          <el-row class="newbox_bb" :style="isactive2 == 1 ? 'display:block': 'display:none' ">
            <el-col :span="15" style="height:390px">
              <div class="newbox_img" :style="is_actives2 == 1 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/pDingDan.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives2 == 2 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/pXiaDan.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives2 == 3 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/pDaying.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives2 == 4 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/pXuanzhe.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives2 == 5 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/pRuku.png" alt width="100%" />
              </div>
            </el-col>
            <el-col :span="8" :offset="1" style="margin-top:60px;padding-left:50px;">
              <ul class="newbox_ul">
                <li :class="is_actives2 == 1? 'is_active' : '' " @mousemove="is_actives2=1">
                  <p>
                    <img src="../assets/订单中心@2x.png" alt />
                  </p>
                  <p>订单中心</p>
                </li>
                <li :class="is_actives2 == 2? 'is_active' : '' " @mousemove="is_actives2=2">
                  <p>
                    <img src="../assets/客户下单@2x.png" alt />
                  </p>
                  <p>顾客下单</p>
                </li>
                <li :class="is_actives2 == 3? 'is_active' : '' " @mousemove="is_actives2=3">
                  <p>
                    <img src="../assets/打印@2x.png" alt />
                  </p>
                  <p>自动打印</p>
                </li>
                <li :class="is_actives2 == 4? 'is_active' : '' " @mousemove="is_actives2=4">
                  <p>
                    <img src="../assets/出库(1)@2x.png" alt />
                  </p>
                  <p>单据出库</p>
                </li>
                <li :class="is_actives2 == 5? 'is_active' : '' " @mousemove="is_actives2=5">
                  <p>
                    <img src="../assets/商品库存@2x.png" alt />
                  </p>
                  <p>商品库存</p>
                </li>
              </ul>
            </el-col>
          </el-row>
          <el-row class="newbox_cc" :style="isactive2 == 2 ? 'display:block': 'display:none' ">
            <el-col :span="21" :offset="1">
              <!-- <video src="../assets/video/批发商视频.mp4" width="100%" height="624px" controls></video> -->
              <a
                target="_blank"
                href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODQwNi5zaHRtbA==.html"
              >
                <img src="../assets/images/homeImg/video.png" width="100%" alt />
              </a>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :offset="20">
              <router-link to="/wholesaler" class="btn" tag="button">查看详情</router-link>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 收银机 加工中心版本 -->
    <el-row style="background-color:#F0EFEF;margin-top:5px" class="jiagong">
      <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
        <div class="newbox">
          <div class="newbox_t">
            <div class="product_b">
              <h3>
                收银机
                <i class="el-icon-remove"></i> 加工中心版本
              </h3>
              <p>加工中心版可让管理化繁为简哦工作流程更简单。</p>
              <p>新建加工单（Pda/微信公众号/商家版收银机），加工中心接受加工单…一整套完整流</p>
            </div>
          </div>
          <el-row class="newbox_top">
            <el-col :span="12" :offset="8">
              <span :class="isactive3==1 ? 'active' :'' " @click="isactive3 =1">页面原型</span>
              <span :class="isactive3==2 ? 'active' :'' " @click="isactive3 =2">视频展示</span>
            </el-col>
          </el-row>
          <el-row class="newbox_bb" :style="isactive3 == 1 ? 'display:block': 'display:none' ">
            <el-col :span="8" style="margin-top:60px;padding-left:0px;">
              <ul class="newbox_ul">
                <li :class="is_actives3 == 1? 'is_active' : '' " @mousemove="is_actives3=1">
                  <p>
                    <img src="../assets/加工中心1@2x.png" alt />
                  </p>
                  <p>加工中心</p>
                </li>
                <li :class="is_actives3 == 2? 'is_active' : '' " @mousemove="is_actives3=2">
                  <p>
                    <img src="../assets/标签@2x.png" alt />
                  </p>
                  <p>加工单据</p>
                </li>
                <li :class="is_actives3 == 3? 'is_active' : '' " @mousemove="is_actives3=3">
                  <p>
                    <img src="../assets/确认@2x.png" alt />
                  </p>
                  <p>确认订单</p>
                </li>
                <li :class="is_actives3 == 4? 'is_active' : '' " @mousemove="is_actives3=4">
                  <p>
                    <img src="../assets/打印加工单@2x.png" alt />
                  </p>
                  <p>打印加工单</p>
                </li>
                <li :class="is_actives3 == 5? 'is_active' : '' " @mousemove="is_actives3=5">
                  <p>
                    <img src="../assets/扫码@2x.png" alt />
                  </p>
                  <p>加工师扫码</p>
                </li>
                <li :class="is_actives3 == 6? 'is_active' : '' " @mousemove="is_actives3=6">
                  <p>
                    <img src="../assets/商品入库@2x.png" alt />
                  </p>
                  <p>成品检测</p>
                </li>
                <li :class="is_actives3 == 7? 'is_active' : '' " @mousemove="is_actives3=7">
                  <p>
                    <img src="../assets/配送@2x.png" alt />
                  </p>
                  <p>指定配送</p>
                </li>
              </ul>
            </el-col>
            <el-col :span="15" :offset="1" style="height:390px">
              <div class="newbox_img" :style="is_actives3 == 1 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/jHome.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives3 == 2 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/jgxq.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives3 == 3 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/jgzx.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives3 == 4 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/jgxq.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives3 == 5 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/jgsjg.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives3 == 6 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/cpjc.png" alt width="100%" />
              </div>
              <div class="newbox_img" :style="is_actives3 == 7 ? 'display:block': 'display:none' ">
                <img src="../assets/images/homeImg/zdps.png" alt width="100%" />
              </div>
            </el-col>
          </el-row>
          <el-row class="newbox_cc" :style="isactive3 == 2 ? 'display:block': 'display:none' ">
            <el-col :span="21" :offset="1">
              <!-- <video src="../assets/video/加工中心版.mp4" width="100%" controls></video> -->
              <a target="_blank" href="http://www.56.com/u60/v_MTU5MDkwOTM3.html">
                <img src="../assets/images/homeImg/video.png" width="100%" alt />
              </a>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :offset="20">
              <router-link
                to="/process"
                class="btn"
                tag="button"
                style="background: transparent"
              >查看详情</router-link>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 移动端产品介绍 -->
    <main>
      <h2>公司产品</h2>
      <div class="tou">
        <ul>
          <li :class="istou==1 ? 'istou': ''" @click="istou=1">零售版本</li>
          <li :class="istou==2 ? 'istou': ''" @click="istou=2">仓库版本</li>
          <li :class="istou==3 ? 'istou': ''" @click="istou=3">批发商版本</li>
          <li :class="istou==4 ? 'istou': ''" @click="istou=4">加工中心版本</li>
        </ul>
      </div>
      <div class="content">
        <div class="content-box" :style="istou==1?'display:block':'display:none'">
          <div class="content-box_t">
            <span :class="isactive==1 ? 'active' :'' " @click="isactive =1">页面原型</span>
            <span :class="isactive==2 ? 'active' :'' " @click="isactive =2">视频展示</span>
          </div>
          <div class="content-box_c" :style="isactive==1? 'display:block': 'display:none'">
            <p>零售版专业为零售店定制的一站式服务系统</p>
            <p>扫码销售/快捷验光，会员共享等</p>
            <img src="../assets/images/homeImg/yinye.png" width="100%" alt />
          </div>
          <div class="content-box_c" :style="isactive==2? 'display:block': 'display:none'">
            <a
              target="_blank"
              href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODM3MS5zaHRtbA==.html"
            >
              <img src="../assets/images/homeImg/video.png" width="100%" alt />
            </a>
          </div>
        </div>
        <div class="content-box" :style="istou==2?'display:block':'display:none'">
          <div class="content-box_t">
            <span :class="isactive==1 ? 'active' :'' " @click="isactive =1">页面原型</span>
            <span :class="isactive==2 ? 'active' :'' " @click="isactive =2">视频展示</span>
          </div>
          <div class="content-box_c" :style="isactive==1? 'display:block': 'display:none'">
            <p>仓库版本让多方工作操作流程明细</p>
            <p>仓库分店出/退/换货，厂家订/采/退/换货，唯一码标签打印等</p>
            <img src="../assets/cangku.png" width="100%" alt />
          </div>
          <div class="content-box_c" :style="isactive==2? 'display:block': 'display:none'">
            <a target="_blank" href="http://www.56.com/u80/v_MTU5MDk0Mzg5.html">
              <img src="../assets/images/homeImg/video.png" width="100%" alt />
            </a>
          </div>
        </div>
        <div class="content-box" :style="istou==3?'display:block':'display:none'">
          <div class="content-box_t">
            <span :class="isactive==1 ? 'active' :'' " @click="isactive =1">页面原型</span>
            <span :class="isactive==2 ? 'active' :'' " @click="isactive =2">视频展示</span>
          </div>
          <div class="content-box_c" :style="isactive==1? 'display:block': 'display:none'">
            <p>批发商版本让管理更加便捷。</p>
            <p>商品入库/商品出库/库存/库存预警提醒，客户管理等</p>
            <img src="../assets/images/homeImg/pDingDan.png" width="100%" alt />
          </div>
          <div class="content-box_c" :style="isactive==2? 'display:block': 'display:none'">
            <a
              target="_blank"
              href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODQwNi5zaHRtbA==.html"
            >
              <img src="../assets/images/homeImg/video.png" width="100%" alt />
            </a>
          </div>
        </div>
        <div class="content-box" :style="istou==4?'display:block':'display:none'">
          <div class="content-box_t">
            <span :class="isactive==1 ? 'active' :'' " @click="isactive =1">页面原型</span>
            <span :class="isactive==2 ? 'active' :'' " @click="isactive =2">视频展示</span>
          </div>
          <div class="content-box_c" :style="isactive==1? 'display:block': 'display:none'">
            <p>加工中心版可让管理化繁为简哦工作流程更简单。</p>
            <p>新建加工单（Pda/微信公众号/商家版收银机）</p>
            <img src="../assets/images/homeImg/jHome.png" width="100%" alt />
          </div>
          <div class="content-box_c" :style="isactive==2? 'display:block': 'display:none'">
            <a target="_blank" href="http://www.56.com/u60/v_MTU5MDkwOTM3.html">
              <img src="../assets/images/homeImg/video.png" width="100%" alt />
            </a>
          </div>
        </div>
      </div>
    </main>

    <!-- 移动端 -->
    <el-row style="background-color:#fff;margin-top:5px;padding-bottom: 110px;" class="yidongduan">
      <el-col :lg="{span:17,offset:4}" :md="{span:24,offset:0}">
        <div class="newbox">
          <div class="newbox_t">
            <div class="product_b">
              <h3>移动端</h3>
              <p>移动销售</p>
              <p>销售单挂起/商品信息同步/订单推送</p>
            </div>
          </div>
          <el-row class="newbox_top">
            <el-col :span="12" :offset="8">
              <span :class="isactive4==1 ? 'active' :'' " @click="isactive4 =1">微信公众号</span>
              <span :class="isactive4==2 ? 'active' :'' " @click="isactive4 =2">微信小程序</span>
            </el-col>
          </el-row>
          <el-row class="newbox_bb" :style="isactive4 == 1 ? 'display:block': 'display:none' ">
            <div class="dis" style="overflow: hidden;display: flex;justify-content: space-around">
              <el-col :span="6" style="min-width:317px;max-width:317px">
                <div
                  class="box"
                  :class="imgids== 1 ? 'box is_box' : ''"
                  @mouseover="addActive($event)"
                >
                  <p>
                    <span class="iconfont">&#xe63f;</span>
                  </p>
                  <p style="font-size:24px;margin:15px 0;">店铺管理</p>
                  <p>老板不用局限时间地点</p>
                  <p>随时审核门店信息</p>
                  <p>店员移动式操作</p>
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                  <p @click="gzh">查看详情...</p>
                </div>
              </el-col>
              <el-col :span="6" style="min-width:317px;max-width:317px">
                <div
                  class="box"
                  :class="imgids== 2 ? 'box is_box' : ''"
                  @mouseover="addActive1($event)"
                >
                  <p>
                    <span class="iconfont">&#xe609;</span>
                  </p>
                  <p style="font-size:24px;margin:15px 0;">店铺信息</p>
                  <p>获取总分店位置信息</p>
                  <p>查看店员详情</p>
                  <p>店铺详情</p>
                  <p>新增硬件设备</p>
                  <p>&nbsp;</p>
                  <p @click="gzh">查看详情...</p>
                </div>
              </el-col>
              <el-col :span="6" style="min-width:317px;max-width:317px">
                <div
                  class="box"
                  :class="imgids== 3 ? 'box is_box' : ''"
                  @mouseover="addActive2($event)"
                >
                  <p>
                    <span class="iconfont">&#xe627;</span>
                  </p>
                  <p style="font-size:24px;margin:15px 0;">信息推送</p>
                  <p>每日营业额更新</p>
                  <p>收款情况、退款统计</p>
                  <p>商品库存查询</p>
                  <p>实时推送一览无余</p>
                  <p>&nbsp;</p>
                  <p @click="gzh">查看详情...</p>
                </div>
              </el-col>
            </div>
          </el-row>
          <el-row class="newbox_bb" :style="isactive4 == 2 ? 'display:block': 'display:none' ">
            <div class="dis" style="overflow: hidden;display: flex;justify-content: space-around">
              <el-col :span="6" style="min-width:317px;max-width:317px">
                <div
                  class="box"
                  :class="imgids== 1 ? 'box is_box' : ''"
                  @mouseover="addActive($event)"
                >
                  <p>
                    <span class="iconfont">&#xe63f;</span>
                  </p>
                  <p style="font-size:24px;margin:15px 0;">店铺管理</p>
                  <p>一键式切换</p>
                  <p>支持多家店务信息查看</p>
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                  <p @click="xcx">查看详情...</p>
                </div>
              </el-col>
              <el-col :span="6" style="min-width:317px;max-width:317px">
                <div
                  class="box"
                  :class="imgids== 2 ? 'box is_box' : ''"
                  @mouseover="addActive1($event)"
                >
                  <p>
                    <span class="iconfont" style="font-weight: 400">&#xe601;</span>
                  </p>
                  <p
                    style="font-size:24px;margin:15px 0;"
                    :style="imgids ==2 ? 'color:#fff' : '' "
                  >会员信息</p>
                  <p :style="imgids ==2 ? 'color:#fff' : '' ">随时随地新建会员</p>
                  <p :style="imgids ==2 ? 'color:#fff' : '' ">查看会员信息</p>
                  <p :style="imgids ==2 ? 'color:#fff' : '' ">节省零碎时间</p>
                  <p :style="imgids ==2 ? 'color:#fff' : '' ">&nbsp;</p>
                  <p>&nbsp;</p>
                  <p :style="imgids ==2 ? 'color:#fff' : '' " @click="xcx">查看详情...</p>
                </div>
              </el-col>
              <el-col :span="6" style="min-width:317px;max-width:317px">
                <div
                  class="box"
                  :class="imgids== 3 ? 'box is_box' : ''"
                  @mouseover="addActive2($event)"
                >
                  <p>
                    <span class="iconfont">&#xe600;</span>
                  </p>
                  <p style="font-size:24px;margin:15px 0;">移动营销</p>
                  <p>销售员移动式营销</p>
                  <p>商品信息随时查看</p>
                  <p>推荐便捷化智能化</p>
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                  <p @click="xcx">查看详情...</p>
                </div>
              </el-col>
            </div>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 移动端移动端 -->
    <div class="zdyidongduan">
      <h2>移动端</h2>
      <div class="zdyidongduant">
        <div class="zdtop">
          <span :class="isactive4==1 ? 'active' :'' " @click="isactive4 =1;">微信小程序</span>
          <span :class="isactive4==2 ? 'active' :'' " @click="isactive4 =2;">微信公众号</span>
        </div>
        <div class="zdtop_c">
          <p>移动销售</p>
          <p>销售单挂起/商品信息同步/订单推送</p>
        </div>

        <div class="boxitems" :style="isactive4==2? 'display:block':'display:none'">
          <div class="boxitem">
            <p>
              <span class="iconfont">&#xe63f;</span>
            </p>
            <p style="font-size:24px;margin:15px 0;">店铺管理</p>
            <p>老板不用局限时间地点</p>
            <p>随时审核门店信息</p>
            <p>店员移动式操作</p>
            <p>&nbsp;</p>
            <p @click="gzh">查看详情...</p>
          </div>
          <div class="boxitem">
            <p>
              <span class="iconfont">&#xe609;</span>
            </p>
            <p style="font-size:24px;margin:15px 0;">店铺信息</p>
            <p>获取总分店位置信息</p>
            <p>查看店员详情</p>
            <p>店铺详情</p>
            <p>新增硬件设备</p>
            <p>&nbsp;</p>
            <p @click="gzh">查看详情...</p>
          </div>
          <div class="boxitem">
            <p>
              <span class="iconfont">&#xe627;</span>
            </p>
            <p style="font-size:24px;margin:15px 0;">信息推送</p>
            <p>每日营业额更新</p>
            <p>收款情况、退款统计</p>
            <p>商品库存查询</p>
            <p>实时推送一览无余</p>
            <p>&nbsp;</p>
            <p @click="gzh">查看详情...</p>
          </div>
        </div>

        <div class="boxitems" :style="isactive4==1? 'display:block':'display:none'">
          <div class="boxitem" ref="box1">
            <p>
              <span class="iconfont">&#xe63f;</span>
            </p>
            <p style="font-size:24px;margin:15px 0;">店铺管理</p>
            <p>一键式切换</p>
            <p>支持多家店务信息查看</p>
            <p>&nbsp;</p>
            <p @click="xcx">查看详情...</p>
          </div>
          <div class="boxitem">
            <p>
              <span class="iconfont">&#xe601;</span>
            </p>
            <p style="font-size:24px;margin:15px 0;">会员信息</p>
            <p>随时随地新建会员</p>
            <p>查看会员信息</p>
            <p>节省零碎时间</p>
            <p>&nbsp;</p>
            <p @click="xcx">查看详情...</p>
          </div>
          <div class="boxitem">
            <p>
              <span class="iconfont">&#xe600;</span>
            </p>
            <p style="font-size:24px;margin:15px 0;">移动营销</p>
            <p>销售员移动式营销</p>
            <p>商品信息随时查看</p>
            <p>推荐便捷化智能化</p>
            <p>&nbsp;</p>
            <p @click="xcx">查看详情...</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 可视化大数据后台 -->
    <div class="visual">
      <img src="../assets/112@2x.png" alt width="100%" />
      <el-row class="visual_t">
        <el-col :span="24">
          <h2>可视化大数据后台</h2>
          <p style="font-size:13px">VISUALIZATION OF BIG DATA BACKGROUND</p>
        </el-col>
      </el-row>
      <div class="users">
        <el-row>
          <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}" class="usersbox">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark users_top">简单、全面、可靠</div>
              </el-col>
            </el-row>
            <el-row class="users_bon">
              <el-col :span="4" :offset="2">
                <div class="grid-content bg-purple-light">
                  <p>用户量</p>
                  <b ref="rollul" class="smoer">{{ list.countVip ? list.countVip :0 | NumFormat}}</b>
                </div>
              </el-col>
              <el-col :span="4" :offset="4">
                <div class="grid-content bg-purple-light">
                  <p>每日使用量</p>
                  <b>{{ list.pricrtCount ? list.pricrtCount: 0 | NumFormat}}</b>
                </div>
              </el-col>
              <el-col :span="5" :offset="3">
                <div class="grid-content bg-purple-light">
                  <p>成交量</p>
                  <b>{{ list.TotalSalesNumber ? list.TotalSalesNumber:0 | NumFormat}}</b>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 移动端大数据后台 -->
    <div class="smallvisual">
      <h2>大数据后台</h2>
      <img src="../assets/images/homeImg/258ffc.png" width="100%" alt />
      <div class="smalluser">
        <div class="smalluser_top">
          <p>简单、全面、可靠</p>
        </div>
        <div class="smalluser_bot">
          <ul>
            <li>
              <p>用户量</p>
              <b>{{ list.countVip ? list.countVip :0 | NumFormat}}</b>
            </li>
            <li>
              <p>每日使用量</p>
              <b>{{ list.pricrtCount ? list.pricrtCount: 0 | NumFormat}}</b>
            </li>
            <li>
              <p>成交量</p>
              <b>{{ list.TotalSalesNumber ? list.TotalSalesNumber:0 | NumFormat}}</b>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 客户案例 -->
    <el-row class="client">
      <el-col :span="24">
        <el-row>
          <el-col :span="24" class="client_top">
            <div class="grid-content bg-purple-dark">
              <h2>合作伙伴</h2>
              <p>COOPERATIVE PARTNER</p>
            </div>
          </el-col>
        </el-row>
        <div class="client_c">
          <el-row class="client_c_t">
            <el-col :span="24" style="padding:0;">
              <div class="grid-content bg-purple imges">
                <img src="../assets/1@2x.png" width="100%" height="100%" alt />
                <img src="../assets/2@2x.png" width="100%" height="100%" alt />
                <img src="../assets/3@2x.png" width="100%" height="100%" alt />
                <img src="../assets/4@2x.png" width="100%" height="100%" alt />
                <img src="../assets/mom.png" width="100%" height="100%" alt />
              </div>
              <div class="imgp">
                <p>镜啡眼镜</p>
                <p>康明眼镜</p>
                <p>诺亚视光</p>
                <p>明锐眼镜</p>
                <p>MOM眼镜</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 移动端客户 -->
    <div class="smallclient">
      <h2>合作伙伴</h2>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/1@2x.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/2@2x.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/mom.png" alt />
          </div>
          <div class="swiper-slide"></div>
        </div>
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/3@2x.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/4@2x.png" alt />
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

    <!-- 品质是我们的责任 -->
    <el-row class="pinzhi">
      <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
        <el-row class="pinzhi_t">
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <h2>品质是我们的责任</h2>
              <p>QUALITY IS OUR RESPONSIBILITY</p>
            </div>
          </el-col>
        </el-row>

        <el-row class="pinzhi_c">
          <el-col :span="24">
            <div class="grid-content bg-purple imges">
              <img src="../assets/h1.png" alt />
              <img src="../assets/h2.png" alt />
              <img src="../assets/h3.png" alt />
              <img src="../assets/h4.png" alt />
            </div>
          </el-col>
        </el-row>
        <el-row class="pinzhi_b">
          <el-col :span="24">
            <div class="grid-content bg-purple imges">
              <img src="../assets/h5.png" alt />
              <img src="../assets/h6.png" alt />
              <img src="../assets/h7.png" alt />
              <img src="../assets/h8.png" alt />
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 移动端品质 -->
    <div class="smallpinzhi">
      <h2>品质是我们的责任</h2>
      <div class="swiper-container1">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/h1.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/h2.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/h3.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/h4.png" alt />
          </div>
        </div>
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/h5.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/h6.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/h7.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/h8.png" alt />
          </div>
        </div>
      </div>
      <div class="swiper-pagination1"></div>
    </div>

    <footers></footers>
  </div>
</template>

<script>
import footer from "../components/footer";
import black from "../assets/blacklogo@2x.png";
import white from "../assets/logo@2x.png";
import header from "../components/headers";
import Swiper from "swiper";
import "../../node_modules/swiper/dist/css/swiper.min.css";
import "element-ui/lib/theme-chalk/display.css";
import { setInterval } from "timers";
import { getpeoples } from "@/api";
import { request } from "http";

export default {
  data() {
    return {
      list: [],
      activeIndex: "1",
      flag: false,
      isactive: 1,
      is_actives: 1,
      isactive1: 1,
      is_actives1: 1,
      isactive2: 1,
      is_actives2: 1,
      isactive3: 1,
      is_actives3: 1,
      isactive4: 1,
      imgurl: {
        black,
        white
      },
      imgids: 2,
      open: false,
      openinfo: false,
      openinfo1: false,
      istou: 1
    };
  },
  methods: {
    handleSelect() {},
    handleClick() {},
    handleScroll() {
      let that = this; //垂直滚动的值兼容问题
      let scrollTopE =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; //offsetTop 属性指定的父坐标的计算顶端位置 offsetHeight获取对象的高度
      // console.log(this.$refs.image);
      // console.log( this.$refs.bannerImg.offsetHeight-50);
      // console.log(scrollTopE);
      let ele = that.$refs.box1;
      var eleHeight = ele.offsetHeight;
      var windowH =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight; // 浏览器高度兼容写法

      var obj = this.getrect(ele);
        if(obj.top >= windowH){
          console.log(123);
          
        }


      let bannerheight = this.$refs.banner.offsetHeight - 50;
      if (scrollTopE > bannerheight) {
        this.$refs.bannerImg.style =
          "background-color: #fff;  box-shadow:rgb(240, 239, 239) 0px 10px 15px;";
        this.flag = true;
      } else {
        this.flag = false;
        this.$refs.bannerImg.style = "";
      }
    },
    getrect(ele) {
      // 视口高度
      var rect = ele.getBoundingClientRect();
      var top = document.documentElement.clientTop
        ? document.documentElement.clientTop
        : 0; // html元素对象的上边框的宽度
      var left = document.documentElement.clientLeft
        ? document.documentElement.clientLeft
        : 0;
      return {
        top: rect.top - top,
        bottom: rect.bottom - top,
        left: rect.left - left,
        right: rect.right - left
      };
    },
    hreftwo() {
      window.location.reload();
      window.scrollTo(0, 0);
    },
    //移动事件
    addActive($event) {
      this.imgids = 1;
    },
    addActive1($event) {
      this.imgids = 2;
    },
    addActive2($event) {
      this.imgids = 3;
    },
    logins() {
      window.location.href = "http://cnc.jingliyun.com/admin/login.html";
    },
    gzh() {
      this.$router.push("/publicNumberProduct");
    },
    xcx() {
      this.$router.push("/smallProgramProduct");
    }
  },
  mounted: function() {
    let that = this;
    that.$nextTick(function() {
      //监听滚动事件
      window.addEventListener("scroll", that.handleScroll);
    });
    // getpeoples().then(res => {
    //   this.list = res.data.map;
    //   // console.log(this.list);
    // });

    // setInterval(() => {
    //   getpeoples();
    // }, 60000);

    var mySwiper = new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination"
      },
      slidesPerView: 2,
      slidesPerColumn: 2,
      slidesPerColumnFill: "row"
    });
    var mySwiper = new Swiper(".swiper-container1", {
      pagination: {
        el: ".swiper-pagination1"
      },
      slidesPerView: 2,
      slidesPerColumn: 2,
      slidesPerColumnFill: "row"
    });
  },
  beforeDestroy() {
    let that = this;
    that.$nextTick(function() {
      //监听滚动事件
      window.removeEventListener("scroll", this.handleScroll);
    });
  },
  components: {
    footers: footer,
    headers: header
  }
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "iconfont";
  src: url("../assets/iconfont/font_home/iconfont.eot");
  src: url("../assets/iconfont/font_home/iconfont.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/iconfont/font_home/iconfont.woff2") format("woff2"),
    url("../assets/iconfont/font_home/iconfont.woff") format("woff"),
    url("../assets/iconfont/font_home/iconfont.ttf") format("truetype"),
    url("../assets/iconfont/font_home/iconfont.svg#iconfont") format("svg");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@media screen and (min-width: 830px) {
  @import url("../assets/css/home/home.less");
}

@media screen and (max-width: 830px) {
  @import url("../assets/css/home/830home.less");
}
</style>